/**
 * Tabs Module
 * Vanilla JS replacement for Bootstrap tabs functionality
 * Handles tab switching with fade animations
 */

import { $$, on, addClass, removeClass, attr, closest } from '../utils/dom.js';

/**
 * Initialize all tabs with data-tab-toggle
 * Replaces Bootstrap tab component with vanilla JS
 */
export const initTabs = () => {
  // Find all tab triggers
  const tabTriggers = $$('[data-tab-toggle]');

  if (!tabTriggers.length) return;

  // Initialize: hide all inactive tabs on page load
  const allTabPanes = $$('.tab-pane');
  allTabPanes.forEach(pane => {
    // Keep only panes that have both 'show' and 'active' classes
    if (!pane.classList.contains('show') || !pane.classList.contains('active')) {
      removeClass(pane, 'show');
      removeClass(pane, 'active');
    }
  });

  // Add click handler to each tab trigger
  on(tabTriggers, 'click', function(e) {
    e.preventDefault();

    // Get the target tab pane ID
    const targetId = attr(this, 'data-tab-target');
    if (!targetId) return;

    const targetPane = document.querySelector(targetId);
    if (!targetPane) return;

    // Get the parent nav container to find siblings
    const navContainer = closest(this, '[role="tablist"]');
    if (!navContainer) return;

    // Deactivate all tab links in this nav
    const allTabLinks = navContainer.querySelectorAll('[data-tab-toggle]');
    removeClass(allTabLinks, 'active');

    // Activate clicked tab link
    addClass(this, 'active');

    // Get the tab content container (parent of all tab panes)
    const tabContentContainer = targetPane.parentElement;

    // Deactivate all tab panes in this container (only direct children, not nested)
    const allTabPanes = tabContentContainer.querySelectorAll(':scope > .tab-pane');
    allTabPanes.forEach(pane => {
      removeClass(pane, 'show');
      removeClass(pane, 'active');
    });

    // Activate target tab pane with fade effect
    // Add 'active' immediately for display, then 'show' for fade-in
    addClass(targetPane, 'active');

    // Small delay to trigger CSS transition
    setTimeout(() => {
      addClass(targetPane, 'show');
    }, 10);

    // For certifications table: ensure first company tab is visible when switching main tabs
    const nestedTabContent = targetPane.querySelector('.tab-content[id*="certifications-table-tab-tableContent"]');
    if (nestedTabContent) {
      const firstCompanyTab = nestedTabContent.querySelector('.company-tab');
      if (firstCompanyTab) {
        // Deactivate all company tabs
        const allCompanyTabs = nestedTabContent.querySelectorAll('.company-tab');
        removeClass(allCompanyTabs, 'show');
        removeClass(allCompanyTabs, 'active');

        // Activate first company tab
        addClass(firstCompanyTab, 'active');
        addClass(firstCompanyTab, 'show');

        // Reset dropdown button active states to match first company
        const allDropdownButtons = nestedTabContent.querySelectorAll('.company-switch-button');
        removeClass(allDropdownButtons, 'active');

        // Set active on the first dropdown button in each dropdown menu
        const allDropdownMenus = nestedTabContent.querySelectorAll('.dropdown-menu');
        allDropdownMenus.forEach(menu => {
          const firstButton = menu.querySelector('.company-switch-button');
          if (firstButton) {
            addClass(firstButton, 'active');
          }
        });
      }
    }
  });
};
